import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import { getErrorAsList } from "../utils";

const initialState = {
  loading: false,
  error: undefined,
  skillCategoryList: [],
};

export const getAllSkillCategories = createAsyncThunk(
  "skillCategories/getAllSkillCategories",
  async (args, thunkAPI) => {
    try {
      const { data } = await api.get("/api/skill-categories/");
      return data;
    } catch (error) {
      console.error(error);
      return thunkAPI.rejectWithValue(getErrorAsList(error));
    }
  }
);

export const skillCategorySlice = createSlice({
  name: "skillCategory",
  initialState,
  extraReducers: {
    // Get all
    [getAllSkillCategories.pending]: (state) => {
      state.loading = true;
    },
    [getAllSkillCategories.fulfilled]: (state, action) => {
      state.loading = false;
      state.error = undefined;
      state.skillCategoryList = action.payload;
    },
    [getAllSkillCategories.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default skillCategorySlice.reducer;
